module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Bold.79a9bb68.woff";